<template>
  <div class="page">
    <div class="navbar">
      <div class="back" @click="$router.push('/')"></div>
      <div class="search" @click="$router.push('/result')">
        <input type="text" readonly placeholder="搜索" />
      </div>
      <!-- <img src="../assets/icon_cart.png" style="width: 0.18rem;margin: 0 0.1rem" />
      <img src="../assets/icon_star.png" style="width: 0.17rem;" /> -->
    </div>

    <div class="detail">
      <div class="detail-banner">
        <!-- <van-swipe @change="onChange">
          <van-swipe-item v-for="(item, index) in detail.pic" :key="index">
            <img :src="item" />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">{{ current + 1 }}/4</div>
          </template>
        </van-swipe> -->
        <img :src="detail.goodsimg" style="width: 100%;" />
      </div>
      <div class="detail-info">

        <div class="detail-info-top">
          <h3>优选价:<strong>￥{{detail.price}}</strong></h3>
          <span @click="jump">某东商品页></span>
        </div>

        <p class="title">
          {{detail.goodsname}}
        </p>
      </div>
      <!-- <div class="detail-param">
        <div class="detail-param-item">
          <div class="label">选择：</div>
          <section class="count" @click="show = true">
            <p>选择 型号 容量</p>
            <div class="box">
              <img src="../assets/img04.png" />
              <img src="../assets/img04.png" />
              <img src="../assets/img04.png" />
              <span>共13种型号可选</span>
            </div>
          </section>
        </div>
        <div class="detail-param-item">
          <div class="label">送至：</div>
          <section class="count">
            <p class="position">山东省青岛市崂山区株洲路190号</p>
          </section>
        </div>
        <div class="detail-param-item">
          <div class="label">参数：</div>
          <section class="count">
            <p>品牌 型号...</p>
          </section>
        </div>
        <div class="detail-param-item">
          <div class="label">邮费：</div>
          <section class="count">
            <p style="background:none;">快递免邮</p>
          </section>
        </div>
        <div class="detail-param-item" style="margin: 0.1rem 0;">
          <div class="label">保障：</div>
          <section class="count">
            <span>正品保障</span>
            <span>极速退款</span>
            <span>7天无理由</span>
          </section>
        </div>
      </div> -->
      <!-- <div class="detail-comment">
        <div class="detail-comment-head">
          <h3 class="num">评价（13万+）</h3>
          <p>好评度<span>99%</span></p>
        </div>
        <div class="detail-comment-list">
          <div class="item" v-for="(item, index) in comments" :key="index">
            <div class="hd">
              <section>
                <img :src="item.avatar" />
                <h4>{{item.username}}</h4>
              </section>
              <section>
                <van-rate color="#EBD28E" :size="11" v-model="item.rate" readonly />
                <p>{{item.create_time}}</p>
              </section>
            </div>
            <div class="content">
              {{item.content}}
            </div>
          </div>
        </div>
        <div class="detail-comment-head">
          <h3 class="num">有图评价（52）</h3>
          <p style="width: 0.3rem;height: 0.17rem;"></p>
        </div>
        <div class="detail-comment-imgs">
          <div class="pic" v-for="(item,index) in comments_img" :key="index">
            <img :src="item.pic" />
            <p>{{item.username}}</p>
          </div>
          <div class="pic" v-for="(item,index) in (4-comments_img.length%4)" v-if="comments_img.length%4 > 0" :key="index"></div>
        </div>
      </div> -->
      <div class="detail-content">
        <div class="pull">
          <img src="../assets/pull_top.png" style="width: 0.12rem;" />上拉查看图文详情
        </div>
        <div class="cont" v-html="detail.content"></div>
      </div>
    </div>

    <van-goods-action>
      <van-goods-action-icon :icon="require('../assets/icon_kefu.png')" @click="call" text="客服" color="#ee0a24" />
      <!-- <van-goods-action-button type="warning" text="加入购物车" />
      <van-goods-action-button type="danger" text="立即购买" @click="buy" /> -->
      <van-goods-action-button type="danger" text="立即购买" @click="buy" />
    </van-goods-action>

    <div class="backtop" @click="backtop">
      <img src="../assets/back_top.png" style="width: 0.34rem;" />
    </div>

    <!-- 商品规格 -->
    <van-sku v-model="show" :sku="sku" :goods="goods" :goods-id="goodsId" :hide-stock="sku.hide_stock" @buy-clicked="onBuyClicked" @add-cart="onAddCartClicked" />
  </div>
</template>
<script>
import { Dialog } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  created() {
    let id = this.$route.query.id
    this.id = id
  },
  mounted() {
    this.getDet()
  },
  data() {
    return {
      id: '',
      keyword: '',
      detail: {},
      current: 0,
      show: false,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          {
            k: '颜色', // skuKeyName：规格类目名称
            k_s: 's1', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            v: [
              {
                id: '1', // skuValueId：规格值 id
                name: '红色', // skuValueName：规格值名称
                imgUrl: 'https://img01.yzcdn.cn/1.jpg', // 规格类目图片，只有第一个规格类目可以定义图片
                previewImgUrl: 'https://img01.yzcdn.cn/1p.jpg', // 用于预览显示的规格类目图片
              },
              {
                id: '1',
                name: '蓝色',
                imgUrl: 'https://img01.yzcdn.cn/2.jpg',
                previewImgUrl: 'https://img01.yzcdn.cn/2p.jpg',
              }
            ],
            largeImageMode: true, //  是否展示大图模式
          }
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
          {
            id: 2259, // skuId
            s1: '1', // 规格类目 k_s 为 s1 的对应规格值 id
            s2: '1', // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110 // 当前 sku 组合对应的库存
          }
        ],
        price: '1.00', // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品
        messages: [
          {
            // 商品留言
            datetime: '0', // 留言类型为 time 时，是否含日期。'1' 表示包含
            multiple: '0', // 留言类型为 text 时，是否多行文本。'1' 表示多行
            name: '留言', // 留言名称
            type: 'text', // 留言类型，可选: id_no（身份证）, text, tel, date, time, email
            required: '1', // 是否必填 '1' 表示必填
            placeholder: '' // 可选值，占位文本
          }
        ],
        hide_stock: false // 是否隐藏剩余库存
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: 'https://img01.yzcdn.cn/1.jpg'
      },
      goodsId: '',
      comments: [
        {
          avatar: require("../assets/img05.png"),
          rate: 4,
          create_time: '2021-03-20',
          content: '清洗师傅很给力清洗的非常到位给师傅好评清洗师傅很给力清洗的非常到位给师傅好评',
          username: '张***花'
        }
      ],
      comments_img: [
        {
          pic: require("../assets/img06.png"),
          username: '许***线'
        }, {
          pic: require("../assets/img06.png"),
          username: '理*********的'
        }
      ]
    }
  },

  methods: {
    getDet() {
      this.common.request({
        url: 'Detail',
        methods: 'post',
        params: { id: this.id },
        callback: res => {
          console.log(res.data.data)
          this.detail = res.data.data
          $("meta[name ='description']").attr('content', this.detail.goodsname);
          $('#wx_JSSDKConfig p').html(this.detail.goodsname)
        }
      })
    },
    // beforeMount() {
    //   // const descriptionEl = document.createElement('meta')
    //   // descriptionEl.content = this.detail.goodsname;
    //   // descriptionEl.name = "description"
    //   // document.head.appendChild(descriptionEl)
    //   console.log('===>', $('meta[property="og:description"]').attr('content'))
    //   $('meta[property="og:description"]').attr('content', '1223');

    // },
    onChange(index) {
      this.current = index;
    },
    jump() {
      window.location.href = this.detail.product_rebate_url
    },
    buy() {
      this.$router.push(`/order?id=${this.detail.id}`)
    },
    backtop() {
      scrollTo(0, 0)
    },
    onBuyClicked() {
      console.log(123)
    },
    onAddCartClicked() {
      console.log(123)
    },
    call() {
      Dialog.confirm({
        title: '客服',
        message: '即将拨打电话：18661777183',
      })
        .then(() => {
          window.location.href = 'tel://18661777183'
        })
        .catch(() => {
          // on cancel
        });
    }
  }
}
</script>
<style lang="less">
.van-goods-action {
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}
.detail_pc {
  img {
    width: 100% !important;
    max-width: 100% !important;
    vertical-align: bottom;
  }
  p {
    img {
      width: 100% !important;
      max-width: 100% !important;
      vertical-align: bottom;
    }
  }
}
.ssd-module-mobile-wrap {
  width: 100% !important;
  max-width: 100% !important;
}
</style>
<style lang="less" scoped>
.page {
  padding-bottom: 50px;
  background-color: #f4f4f4;
  .navbar {
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    .back {
      width: 0.09rem;
      height: 0.3rem;
      background: url("../assets/icon_back.png") no-repeat;
      background-size: 0.09rem auto;
      background-position: left center;
      padding-right: 0.26rem;
    }
    .search {
      width: 100%;
      height: 0.3rem;
      background-color: #ededed;
      border-radius: 0.15rem;
      background-image: url("../assets/icon_search.png");
      background-size: 0.17rem auto;
      background-position: 0.1rem center;
      background-repeat: no-repeat;
      input {
        width: 100%;
        height: 100%;
        padding-left: 0.35rem;
        font-size: 0.14rem;
        color: #666666;
      }
    }
  }
  .detail {
    &-banner {
      background-color: #fff;
      .custom-indicator {
        position: absolute;
        right: 0.12rem;
        top: 0.2rem;
        padding: 0.015rem 0.15rem;
        font-size: 0.12rem;
        color: #fff;
        background: rgba(51, 51, 51, 0.6);
        border-radius: 0.1rem;
      }
    }
    &-info {
      padding: 0.1rem;
      background-color: #fff;
      // border-bottom: 0.1rem solid #f7f7f7;
      &-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        h3 {
          font-size: 0.15rem;
          color: #c90827;
          strong {
            font-size: 0.19rem;
          }
        }
        span {
          font-size: 0.14rem;
          color: #988256;
          background-color: #f0ece1;
          padding: 0 0.08rem;
          border-radius: 0.11rem 0 0 0.11rem;
          margin-right: -0.1rem;
        }
      }
      & > .title {
        font-size: 0.15rem;
        color: #333333;
        line-height: 0.21rem;
        margin: 0.08rem 0 0;
        // background: url("../assets/icon_JD.png") no-repeat;
        // background-size: 0.16rem auto;
        // background-position: left 0.02rem;
        // text-indent: 0.18rem;
      }
    }
    &-param {
      &-item {
        display: flex;
        padding: 0.15rem 0.1rem 0;
        background-color: #fff;
        .label {
          width: 0.5rem;
          font-size: 0.14rem;
          color: #999;
        }
        .count {
          width: calc(100% - 0.5rem);
          border-bottom: 1px solid #f2f2f2;
          padding-bottom: 0.15rem;
          & > p {
            font-size: 0.14rem;
            color: #333333;
            background: url("../assets/arrow_right.png") no-repeat;
            background-size: 0.09rem auto;
            background-position: right center;
          }
          .position {
            &::before {
              content: "";
              display: inline-block;
              width: 0.1rem;
              height: 0.12rem;
              background: url("../assets/icon_address.png") no-repeat;
              background-size: 100% auto;
              margin-right: 0.05rem;
            }
          }
          & > span {
            font-size: 0.14rem;
            color: #333333;
            margin-right: 0.1rem;
            &::before {
              content: "";
              display: inline-block;
              width: 0.12rem;
              height: 0.12rem;
              background: url("../assets/icon_right.png") no-repeat;
              background-size: 100% 100%;
              margin-right: 0.03rem;
            }
          }
          & > .box {
            display: flex;
            align-items: center;
            padding-top: 0.15rem;
            img {
              width: 0.52rem;
              height: 0.52rem;
              object-fit: contain;
              border-radius: 0.05rem;
              margin-right: 0.05rem;
            }
            span {
              font-size: 0.11rem;
              color: #515151;
              background-color: #f1f1f1;
              border-radius: 0.05rem;
              padding: 0 0.05rem;
            }
          }
        }
      }
    }
    &-comment {
      background-color: #fff;
      padding: 0 0.1rem;
      &-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.1rem 0;
        border-bottom: 1px solid #f2f2f2;
        .num {
          font-size: 0.15rem;
          color: #333333;
          position: relative;
          padding-left: 0.08rem;
          &::before {
            content: "";
            display: inline-block;
            width: 0.035rem;
            height: 0.145rem;
            background: #ebd28e;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        & > p {
          font-size: 0.12rem;
          color: #333333;
          background: url("../assets/arrow_right.png") no-repeat;
          background-size: 0.09rem auto;
          background-position: right center;
          padding-right: 0.15rem;
          span {
            color: #999;
          }
        }
      }
      &-list {
        & > .item {
          padding: 0.1rem 0;
          border-bottom: 1px solid #f2f2f2;
          .hd {
            display: flex;
            align-items: center;
            justify-content: space-between;
            section {
              &:first-child {
                display: flex;
                align-items: center;
                img {
                  width: 0.25rem;
                  height: 0.25rem;
                  border-radius: 50%;
                  object-fit: contain;
                }
                h4 {
                  font-size: 0.12rem;
                  color: #333;
                  margin-left: 0.1rem;
                }
              }
              &:nth-child(2) {
                & > p {
                  font-size: 0.11rem;
                  color: #999;
                  text-align: right;
                }
              }
            }
          }
          & > .content {
            line-height: 1.5;
            color: #333;
            font-size: 0.14rem;
            padding: 0.1rem 0;
          }
        }
      }
      &-imgs {
        display: flex;
        justify-content: space-between;
        padding: 0.1rem 0;
        .pic {
          width: 0.78rem;
          img {
            width: 0.78rem;
            height: 0.78rem;
          }
          p {
            font-size: 0.12rem;
            color: #333;
          }
        }
      }
    }
    &-content {
      .pull {
        background-color: #f4f4f4;
        padding: 0.15rem 0;
        text-align: center;
        font-size: 0.12rem;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          flex-shrink: 0;
          height: 100%;
          margin-right: 0.05rem;
        }
      }
      .cont {
        width: 100%;
        img {
          width: 100% !important;
          max-width: 100% !important;
          vertical-align: bottom;
        }
      }
    }
  }
  .backtop {
    position: fixed;
    right: 0.1rem;
    bottom: 70px;
  }
}
</style>